<div class="py-md-3 py-md-0 bg-devices">
	<div class="site-content">
		<div class="row pb-3">
      <div class="col-12">
        <div class="row order-wrapper">
          <div class="col-md-5 col-sm-12 mx-auto my-auto only my-5 px-0">
            <div class="divisas-row">
              <div class="divisas-col-12">
                <h4 class="text-center text-sm-left">{{ 'LANDING.DEVICES.TITLE' | translate }}</h4>
              </div>
              <div class="divisas-col-12">
                <p class="subtitulo text-center text-sm-left">{{ 'LANDING.DEVICES.SUBTITLE' | translate }}</p>
              </div>
              @if (appStoreUrl || googlePlayUrl) {
                <div class="divisas-col-12">
                  <div class="row g-3 mt-2 mt-md-3 justify-content-center justify-content-sm-start align-items-center store-badges-row">
                    @if (appStoreUrl) {
                      <div class="col-6 col-sm-auto text-center text-sm-start px-2">
                        <a [href]="appStoreUrl" target="_blank" rel="noopener noreferrer" class="d-inline-block">
                          <img class="img-fluid store-badge-img px-sm-2" src="./assets/img/ios-app-store.png" alt="App Store" />
                        </a>
                      </div>
                    }
                    @if (googlePlayUrl) {
                      <div class="col-6 col-sm-auto text-center text-sm-start px-2">
                        <a [href]="googlePlayUrl" target="_blank" rel="noopener noreferrer" class="d-inline-block">
                          <img class="img-fluid store-badge-img px-sm-1" src="./assets/img/google-play.png" alt="Google Play" />
                        </a>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-2"></div>
          <div class="col-md-5 col-sm-12 my-5" style="display: flex; justify-content: center; margin: 40px auto;">
            <img class="img-app" [src]="deviceMockupImageUrl" alt="">
          </div>
        </div>
      </div>
		</div>
	</div>
</div>
